import React from 'react';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';

import css from './ListingPage.module.css';

const SectionGallery = props => {
  const { listing, variantPrefix } = props;
  const images = listing.images;

  // Gallery variants: aspect-ratio preserving (no crop) — requested in ListingPage.duck.js
  const galleryVariants = ['listing-gallery', 'listing-gallery-2x'];
  // Platform built-in scaled variants (may not exist for all images)
  const scaledVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];
  const croppedVariants = [
    variantPrefix,
    `${variantPrefix}-2x`,
    `${variantPrefix}-4x`,
    `${variantPrefix}-6x`,
  ];

  // Prefer gallery (scaled) variants; fall back to platform scaled, then cropped
  const hasGalleryVariant = galleryVariants.some(v => images?.[0]?.attributes?.variants?.[v]);
  const hasAnyScaledVariant = scaledVariants.some(v => images?.[0]?.attributes?.variants?.[v]);
  const imageVariants = hasGalleryVariant
    ? galleryVariants
    : hasAnyScaledVariant
    ? scaledVariants
    : croppedVariants;
  const thumbnailVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`];
  return (
    <section className={css.productGallery} data-testid="carousel">
      <ListingImageGallery
        images={images}
        imageVariants={imageVariants}
        thumbnailVariants={thumbnailVariants}
      />
    </section>
  );
};

export default SectionGallery;
